import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=3bb16fb9&scoped=true&"
import script from "./Campaign.vue?vue&type=script&lang=js&"
export * from "./Campaign.vue?vue&type=script&lang=js&"
import style0 from "./Campaign.vue?vue&type=style&index=0&id=3bb16fb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb16fb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb16fb9')) {
      api.createRecord('3bb16fb9', component.options)
    } else {
      api.reload('3bb16fb9', component.options)
    }
    module.hot.accept("./Campaign.vue?vue&type=template&id=3bb16fb9&scoped=true&", function () {
      api.rerender('3bb16fb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/campaigns/Campaign.vue"
export default component.exports